export const STATUSES = {
  CREATING: ['create', 'pending_create'],
  FAILED: ['failed_create'],
  RESETTING: ['pending_reset', 'reset'],
  FAILED_RESET: ['failed_reset'],
  DELETING: ['pending_delete', 'delete'],
  FAILED_DELETE: ['failed_delete'],
  SUSPENDED: ['decom', 'disabled', 'tos', 'aup'],
};

export const AI_PLANS = {
  go_starter: 'Get Online',
  go_grow: 'Get Online Grow',
  go_scale: 'Get Online Scale',
  so_starter: 'Sell Online',
  so_grow: 'Sell Online Grow',
  so_scale: 'Sell Online Scale',
};

export const GET_ONLINE_FREE_TRIAL_SKU = 'BH_PKG_FREE_TRIAL';
export const SELL_ONLINE_FREE_TRIAL_SKU = 'BH_PKG_FREE_TRIAL_COMMERCE';

export const GET_ONLINE_PAID_SKUS = [
  'AI_SITE_WEBSITE',
  'AI_SITE_WEBSITE_P2',
  'AI_SITE_WEBSITE_P3',
] as readonly string[];

export const SELL_ONLINE_PAID_SKUS = [
  'AI_SITE_COMMERCE',
  'AI_SITE_COMMERCE_P2',
  'AI_SITE_COMMERCE_P3',
] as readonly string[];

export const FREE_TRIAL_LEFT_DAYS_WARNING_THRESHOLD = 3;
